import React, { useContext, useMemo, useState, useEffect } from 'react';

import { Button } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';

import axios from '../../sharedModules/utils/axios.utils';
import ListPage from '../../sharedModules/listPage/ListPage';
import { AuthenticationContext } from '../../homeModules/auth/contexts/AuthenticationContext';

const PhotoPagesXoiJobsListPage: React.FC = () => {
  const { user } = useContext(AuthenticationContext);
  const [ownerOptions, setOwnerOptions] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    axios
      .get('/developers/xoi_jobs/new')
      .then((response: any) => {
        setOwnerOptions(response.data.owner_choices || []);
      })
      .catch(() => {});
  }, []);

  const defaultFilterSetting = useMemo(() => {
    if (!user?.email) return undefined;
    return { assignee_email_eq: user.email };
  }, [user?.email]);

  const clearedFilterSetting = { assignee_email_eq: 'all' };

  const filterDefinitions = [
    {
      label: 'Job Owner',
      type: 'autocomplete',
      choices: ownerOptions,
      param: 'assignee_email_eq',
      width: 3,
    },
  ];

  const photoPageXoiJobColumns = [
    {
      name: 'Customer',
      selector: 'customer_name',
      sortable: true,
      grow: 1,
    },
    {
      name: 'Location',
      selector: 'job_location',
      sortable: true,
    },
    {
      name: 'Order',
      selector: 'work_order_number',
      sortable: true,
      grow: 0.5,
    },
    {
      name: 'Created By',
      selector: 'created_by_name',
      sortable: false,
    },
    {
      name: 'Complete',
      selector: 'completed_at_display',
      sortable: true,
      grow: 1.25,
    },
    {
      name: 'Proposal PDF',
      selector: 'pdf_template_url',
      grow: 0.75,
      cell: (row) =>
        row.download_url && (
          <a href={row.download_url} target="_blank" rel="noopener noreferrer" aria-label="View proposal PDF">
            <Button variant="contained" color="primary" aria-label="View proposal PDF">
              <Visibility />
            </Button>
          </a>
        ),
    },
  ];

  return (
    <ListPage
      key={user?.email || 'loading'}
      clickableRows
      clearedFilterSetting={clearedFilterSetting}
      columns={photoPageXoiJobColumns}
      controller="developers/xoi_jobs"
      defaultFilters={defaultFilterSetting}
      defaultSort="created_at desc"
      filterDefinitions={filterDefinitions}
      includeFilterBar
      queryPlaceholder="Filter by customer name..."
      rowClickPath="photo_proposals"
      title="XOI Jobs"
    />
  );
};

export default PhotoPagesXoiJobsListPage;
